import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { TimelineAssetActions } from '../store/slice'

/** Consume the cross-route notice once, then keep it only for this landing-page visit. */
export function useAddFilesLeaseExpiredNotice(matterId?: string) {
  const { key } = useLocation()
  const dispatch = useAppDispatch()
  const expiredMatterId = useAppSelector((state) => state.timelineAssetState.addFilesLeaseExpiredMatterId)
  const [notice, setNotice] = useState({ key, matterId, visible: Boolean(matterId && expiredMatterId === matterId) })

  if (notice.key !== key || notice.matterId !== matterId) {
    setNotice({ key, matterId, visible: false })
  }

  useEffect(() => {
    if (expiredMatterId) dispatch(TimelineAssetActions.setAddFilesLeaseExpiredMatterId(null))
  }, [expiredMatterId, dispatch])

  return notice.visible
}
